import React from 'react';
import MaterialTable from 'material-table';
import { Container, Spinner, Row, Button, Col, Form } from 'react-bootstrap';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import { withAuthorization } from '../Session';
import * as ROUTES from '../../constants/routes';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';
import { dateFormatUtil ,getFormattedDateTime,getFormattedDate} from '../Utilities';

const columns = [
    { title: 'Name', field: 'Name' },
    { title: 'Mobile', field: 'MobileNumber' },
    { title: 'City', field: 'City' },
    { title: 'State', field: 'State' },
    { title: 'Referred By Store Tag', field: 'ReferralTag' },
    {title:"Referred On", field:"DateOfReferral",render: (item) => getFormattedDateTime(item.DateOfReferral)},
    //{title:"Referred By Phone", field:"ReferralPhoneNumber"}
];

const pageSizes = [5, 10, 25, 50, 100];
const searchBy = [
    { key: 'Name', value: 'Name' },
    { key: 'Phone Number', value: 'MobileNumber' },
    { key: 'City', value: 'City' },
    { key: 'State', value: 'State' },
    { key: 'Referred By Store Tag', value: 'ReferralTag' }
];

class ReferralData extends React.Component {
    _isMounted = false;
    state = {
        perPage: 5,
        pageNumber: 0,
        LastDocument: false,
        FirstDocument: false,
        StartAt: [],
        moveTo: false,
        search_key: '',
        search_by: 'Name',

        data: [],
        flag: false,
        alert: 0,
        alertMessage: ''
    };

    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        this._isMounted = true;
        this.loadData();
    }

    async loadData() {
        if (this._isMounted) {
            this.setState({ flag: false });
        }
        let bodyData = {
            search_key: this.state.search_key,
            search_by: this.state.search_by,
            userRole:
                this.props.role == 'StoreOwners'
                    ? 'StoreOwner'
                    : this.props.role,
            LastDocument: this.state.LastDocument,
            FirstDocument: this.state.FirstDocument,
            StartAt: await this.getStartAt(),
            perPage: parseInt(this.state.perPage),
            moveTo: this.state.moveTo
        };

        await RestServices.getReferralData(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then((responseData) => {
                
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            flag: true,
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    if (this.state.moveTo === 'Prev') {
                        var newPageNumber = this.state.pageNumber - 1;
                        var filteredArray = this.state.StartAt.filter(
                            (item) => item !== responseData.FirstDocument
                        );
                        if (filteredArray.length < 2) {
                            var filteredArray = [];
                            filteredArray.push(responseData.FirstDocument);
                        }
                    } else if (this.state.moveTo === 'Next') {
                        var newPageNumber = this.state.pageNumber + 1;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    } else {
                        var newPageNumber = 0;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    }

                    if (this._isMounted) {
                        this.setState({
                            pageNumber: newPageNumber,
                            StartAt: filteredArray,
                            LastDocument: responseData.LastDocument,
                            FirstDocument: responseData.FirstDocument,
                            data: responseData.list,
                            flag: true,
                            alert: 0
                        });
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        flag: true,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }

    getStartAt = () => {
        let StartAtLIst = this.state.StartAt;

        if (StartAtLIst.length > this.state.pageNumber + 1) {
            StartAtLIst.splice(StartAtLIst.length - 2, StartAtLIst.length - 1);
            if (this._isMounted) {
                this.setState({ StartAt: StartAtLIst });
            }
        }
        return StartAtLIst[this.state.pageNumber - 1];
    };

    handlePageSizeChange = (event) => {
        if (this._isMounted) {
            this.setState({
                perPage: event.target.value,
                moveTo: false,
                StartAt: [],
                pageNumber: 0
            });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    submitSearch = () => {
        this.setState({
            moveTo: false,
            StartAt: [],
            pageNumber: 0,
            FirstDocument: false,
            LastDocument: false
        });
        setTimeout(() => {
            this.loadData();
        }, 500);
    };

    restSearch = () => {
        this.setState({
            search_key: '',
            moveTo: false,
            StartAt: [],
            pageNumber: 0
        });
        setTimeout(() => {
            this.loadData();
        }, 500);
    };
    paginateNext = () => {
        
        if (this._isMounted) {
            this.setState({ flag: true, moveTo: 'Next' });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    paginatePrev = () => {
        if (this._isMounted) {
            this.setState({ flag: true, moveTo: 'Prev' });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    onChangeValues = (event) => {
        if (event.target.value === '')
            this.setState({ [event.target.name]: '' });
        else {
            this.setState({ [event.target.name]: event.target.value });
        }
    };

    render() {
        const actions = [
            /* {
           icon: 'preview',
           tooltip: 'View Refferal Profile',
           onClick: (event, rowData) => {
           if(rowData.ReferralAadharNumber){
           this.props.history.push(ROUTES.ViewProfile,{ AadharNumber: rowData.ReferralAadharNumber});
           }
           }
       }*/
        ];

        return (
            <Container>
                <Row>
                    <h4 style={{ marginLeft: '1rem' }}>Referrals Details</h4>
                </Row>
                <div>
                    <hr />
                </div>

                {this.state.alert === 1 && (
                    <Row>
                        <Col>
                            <Alert variant="danger">
                                {this.state.alertMessage}
                            </Alert>
                        </Col>
                    </Row>
                )}

                {this.state.flag === false && <Spinner animation="border" />}

                <div>
                    <hr />
                </div>
                <Row style={{ justifyContent: 'right' }}>
                    <Col
                        style={{ justifyContent: 'right', textAlign: 'right' }}
                    >
                        <Form.Group
                            as={Row}
                            style={{
                                justifyContent: 'right',
                                marginRight: '0'
                            }}
                        >
                            <select
                                className="form-control"
                                style={{ width: 'auto' }}
                                name="search_by"
                                onChange={this.onChangeValues}
                                value={this.state.search_by}
                            >
                                {searchBy.map((search) => (
                                    <option
                                        key={search.value}
                                        value={search.value}
                                    >
                                        Search By {search.key}
                                    </option>
                                ))}
                            </select>
                            <Form.Control
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem',
                                    width: 'auto'
                                }}
                                placeholder="Search key"
                                type="text"
                                name="search_key"
                                value={this.state.search_key}
                                onChange={this.onChangeValues}
                            />
                            <Button
                                variant="primary"
                                onClick={this.submitSearch}
                            >
                                Search
                            </Button>

                            <Button
                                style={{ marginLeft: '1rem' }}
                                variant="primary"
                                onClick={this.restSearch}
                            >
                                Reset
                            </Button>
                        </Form.Group>
                    </Col>
                </Row>

                {this.state.flag && (
                    <MaterialTable
                        title="Referrals Data"
                        columns={columns}
                        data={this.state.data}
                        actions={actions}
                        options={{
                            filtering: false,
                            search: false,
                            sorting: false,
                            paging: false,
                            actionsColumnIndex: -1
                        }}
                    />
                )}
                <div>
                    <hr />
                </div>
                <Row className="custom_pagination">
                    {this.state.StartAt.length > 1 && (
                        <Col>
                            <Button
                                onClick={this.paginatePrev}
                                variant="primary"
                            >
                                Prev
                            </Button>
                        </Col>
                    )}
                    {this.state.StartAt.length < 2 && (
                        <Col>
                            <Button variant="secondary" disabled={true}>
                                Prev
                            </Button>
                        </Col>
                    )}

                    <Col style={{ textAlign: 'center' }}>
                        {'Items per page:'}
                        <select
                            className="items_per_page"
                            onChange={this.handlePageSizeChange}
                            value={this.state.perPage}
                        >
                            {pageSizes.map((size) => (
                                <option key={size} value={size}>
                                    {size}
                                </option>
                            ))}
                        </select>
                        Page: {this.state.StartAt.length}
                    </Col>

                    <Col style={{ textAlign: 'right' }}>
                        {this.state.data.length < this.state.perPage && (
                            <Button variant="secondary" disabled={true}>
                                Next
                            </Button>
                        )}

                        {this.state.data.length >= this.state.perPage && (
                            <Button
                                onClick={this.paginateNext}
                                variant="primary"
                            >
                                Next
                            </Button>
                        )}
                    </Col>
                </Row>
            </Container>
        );
    }
}

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(ReferralData);
